import { getConfig } from '@klpkonsern/appconfig';
import i18n from 'i18next';

/**
 * Gets the Dynamics 365 URL from configuration
 */
export const getDynamics365URL = () => getConfig('WEBAPP_APP_DYNAMICS365_LINK');

/**
 * Gets localized label with fallback support
 */
export const getLocalizedLabel = (
    translationKey: string,
    fallbackLabel: string | undefined, // @TODO: Do we use it without fallbackLabel somewhere? If not, remove undefined
    fieldId: string | undefined, // @TODO: Do we use it without fieldId somewhere? If not, remove undefined
) => {
    const translation = i18n.t(translationKey);

    return fallbackLabel ? fallbackLabel : (translation ?? fieldId);
};

export const getLocalizedRoles = (
    rolesString: string | undefined,
): string | undefined => {
    if (!rolesString) return undefined;

    const rolesArray = rolesString.split(',').map((role) => role.trim());
    const localizedRoles = rolesArray.map((role) =>
        i18n.t(`formGenerator.roles.${role}`),
    );

    return localizedRoles.join(', ');
};

/**
 * Gets an object from a list by ID
 */
export const getObjectFromListById = <T extends { id?: string }>(
    id: string,
    list?: Array<T>,
): T | undefined => {
    return list?.find((item) => item.id === id);
};

type parsedObjectWithId = {
    id: string;
};

/**
 * Gets an object from a list by parsing a JSON string and extracting the ID
 */
export const getObjectFromListByIdOfObject = <T extends { id?: string }>(
    jsonString: string,
    list: Array<T>,
): T | undefined => {
    try {
        const parsed = JSON.parse(jsonString) as parsedObjectWithId;
        return list.find((item) => item.id === parsed.id);
    } catch (e) {
        return undefined;
    }
};

/**
 * Parses a JSON string into an array of strings
 */
export const parseJsonArrayOfStrings = (
    jsonString: string | null,
): Array<string> => {
    if (!jsonString) return [];

    try {
        const parsed = JSON.parse(jsonString);

        if (
            Array.isArray(parsed) &&
            parsed.every((item) => typeof item === 'string')
        ) {
            return parsed;
        }

        return [];
    } catch (e) {
        console.error('Invalid JSON format', e);
        return [];
    }
};

/**
 * Parses a JSON string into an array of translated strings
 */
export const parseTranslatedJsonArrayOfStrings = (
    jsonString: string,
    locale: string,
) => {
    try {
        const parsed = JSON.parse(jsonString);

        if (Array.isArray(parsed)) {
            return parsed.map((item) => ({
                id: item?.id || item,
                label: item[locale] || item?.default || item,
            }));
        }

        return [];
    } catch (error) {
        console.error('Invalid JSON format', error);
        return [];
    }
};
